// Копия витрины: site/src/shared/utils/fonts.ts.
// При изменении оригинала синхронизировать этот файл.

/** Шрифты витрины по умолчанию (макет OTT Constructor Redesign). */
export const DEFAULT_FONTS = { heading: "Archivo", base: "Manrope" } as const;

const GENERIC_FAMILIES = new Set([
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui",
  "ui-sans-serif",
  "ui-serif",
  "ui-monospace",
]);

/**
 * Разбирает CSS-строку `font-family` из настроек платформы: первое семейство
 * идёт в Google Fonts, вся строка (при необходимости с добавленным generic
 * фолбэком) идёт в тему, чтобы до загрузки шрифта текст рисовался ближайшим
 * системным, а не пустотой.
 */
export function parseFontFamily(
  value: string | null | undefined
): { family: string; stack: string } | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  const parts = trimmed
    .split(",")
    .map((part) => part.trim().replace(/^['"]|['"]$/g, ""))
    .filter(Boolean);
  const family = parts[0];
  if (!family) return null;

  const hasGeneric = parts.some((part) =>
    GENERIC_FAMILIES.has(part.toLowerCase())
  );
  const stack = hasGeneric ? trimmed : `${trimmed}, sans-serif`;

  return { family, stack };
}

const WEIGHTS = "400;500;600;700;800;900";

export function buildGoogleFontsUrl(families: string[]): string | null {
  if (families.length === 0) return null;
  const query = families
    .map(
      (family) => `family=${family.trim().replace(/\s+/g, "+")}:wght@${WEIGHTS}`
    )
    .join("&");
  return `https://fonts.googleapis.com/css2?${query}&display=swap`;
}
